module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_7005.1fcf3539.png";